import { useEffect } from 'react';

interface ServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  service: {
    title: string;
    description: string;
    icon: string;
    features: string[];
    detailedInfo: string;
    image: string;
  } | null;
}

const ServiceModal = ({ isOpen, onClose, service }: ServiceModalProps) => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtadilatfirmasi.com web siteniz üzerinden yazıyorum.\nTadilat, dekorasyon ve iç mimarlık hizmetleriniz hakkında bilgi ve fiyat teklifi almak istiyorum.');

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !service) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="relative bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all duration-300 cursor-pointer"
          aria-label="Kapat"
        >
          <i className="ri-close-line text-2xl text-wood-dark"></i>
        </button>

        {/* Image */}
        <div className="relative h-64 md:h-80 w-full overflow-hidden rounded-t-3xl">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
          <div className="absolute bottom-6 left-6 right-6">
            <div className="flex items-center space-x-4 mb-3">
              <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-white">{service.title}</h2>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 md:p-8">
          <p className="text-base md:text-lg text-wood mb-6 leading-relaxed">{service.description}</p>

          <div className="mb-8">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-wood-dark mb-4">Daha Fazla Bilgi</h3>
            <p className="text-sm md:text-base text-wood/80 leading-relaxed whitespace-pre-line">{service.detailedInfo}</p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-wood-dark mb-4">Hizmet Kapsamı</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {service.features.map((feature, idx) => (
                <div key={idx} className="flex items-center text-sm md:text-base text-wood bg-cream p-3 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-wood mr-3 flex-shrink-0 text-lg"></i>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-wood/10">
            <a
              href="tel:05421138110"
              className="flex-1 px-6 py-3 bg-wood hover:bg-wood-dark text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-center text-sm md:text-base"
            >
              Hemen Ara: 0542 113 81 10
            </a>
            <a
              href={`https://wa.me/905421138110?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 px-6 py-3 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-center text-sm md:text-base"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
